module.exports = __webpack_public_path__ + "static/img/德誠資訊logo_3.5ba87166.png";